import { defineAsyncComponent } from "vue";

const AppsPopover = defineAsyncComponent(() => import("./ui/apps-popover.vue"));

export { AppsPopover };
